import { pathBuilder } from './index';

export const root = '/admin/destruction_events';

export default pathBuilder(root);
